import React from "react";
import CandleLeImage from "../../assets/img/candle-le-image.png";
import "./About.css";

const About = () => {
  return (
    <section id="about-section">
      <div className="about-container">
        <img
          className="candle-le-image"
          src={CandleLeImage}
          alt="Logo de velas artesanales Candle Le"
        />
        <div className="about-content">
          <h1 className="about-title">
            El Arte de la Luz: Velas Artesanales Hechas con Amor
          </h1>

          <div className="about-features">
            <div className="feature">
              <h3>Ingredientes Naturales 🌿</h3>
              <p>
                Elaboradas con cera de soja orgánica y mechas de algodón, nuestras
                velas aportan un toque puro, natural y ecológico a cualquier
                espacio.
              </p>
            </div>

            <div className="feature">
              <h3>Detalles Únicos 💝</h3>
              <p>
                Velas hechas a mano con diseños exclusivos, pensadas para crear
                ambientes cálidos, elegantes y acogedores.
              </p>
            </div>

            <div className="feature">
              <h3>Eventos y Celebraciones ✨</h3>
              <p>
                Realizamos pedidos especiales para eventos como bodas,
                cumpleaños, comuniones y celebraciones privadas. Velas ideales
                como adornos, centros de mesa o detalles para invitados.
              </p>
            </div>

            <div className="feature">
              <h3>Regalo Perfecto 🎁</h3>
              <p>
                Un detalle original y personalizado para sorprender en cualquier
                ocasión especial.
              </p>
            </div>

            <div className="feature">
              <h3>Sostenibilidad 🌍</h3>
              <p>
                Apostamos por procesos responsables y materiales eco-friendly
                para minimizar el impacto ambiental.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
